const B = "https://static.prod-images.emergentagent.com/jobs/64e15ce1-d0bf-48bd-abb1-e4e08d284a73/images/";

// Cinematic AI scenes (on-brand, blue-steel palette)
export const ASSETS = {
  heroDesktop: B + "f6f5cbe918f4c4d7e55148bdc4afff6d28f8e129bee4fc538e767e8e224a1e2a.jpeg",
  heroMobile: B + "4c329b14b2d633d0a065f6b0f6860ca703ff15bb8604e31709c1a95a85b4cb3c.jpeg",
  tankInterior: B + "3f5a71ccba0ab9001a24fe212dc45aeb19a76e141b4db9bda07e298542dcca5a.jpeg",
  polyureaRoof: B + "54d4186aa0b907238b0f0b1949a82fe157b9c67ecc2f0de66ef4fcaa17c6a27d.jpeg",
  protectivePainting: B + "06d9f3fa29746ab665842f98c85c04b9336203b23b96f9a9302f9be798a6a24c.jpeg",
  inspectionTablet: B + "4f972ed9bab2cbfab7dbb4b939c68ccfd6adf943e2b791d9f71a990c3e5c82b8.jpeg",
  surveyTeam: B + "aa6a9fdd5af47954ce80b26e643bbf05fec252fa388a63662833235f90fcef24.jpeg",
  siteSetup: B + "c068e1a430e8e9a44c905fcf51a7f5810e6d39e261f9313be5a649791b01c511.jpeg",
  bgNavyTexture: B + "59614ab542236a46760972c40b0f8c29278317b7ce550e3a21aff86980846ee5.jpeg",
  bgLightTexture: B + "62e38547361eaf738c81ec0d151ccca9e2a6bfee6ff1c389921a2c449e472b84.jpeg",

  // Real brand assets (client-provided)
  brandSymbol: "/assets/brand/logo-symbol.svg",
  brandSymbolPng: "/assets/brand/icona.png",
  logoHorizontal: "/assets/brand/logo-orizzontale.png",
  logoVertical: "/assets/brand/logo-verticale.png",

  // Real IQNet certification badges (client-provided)
  certs: {
    iso9001: "/assets/certifications/iso-9001.png",
    iso14001: "/assets/certifications/iso-14001.png",
    iso45001: "/assets/certifications/iso-45001.png",
  },

  // Real equipment photos (client-provided, Opzione B)
  equip: {
    piattaforma: "/assets/equipment/piattaforma.png",
    sabbiatrice: "/assets/equipment/sabbiatrice.png",
    motocompressore: "/assets/equipment/motocompressore.png",
    ecoquip: "/assets/equipment/ecoquip.png",
    pallinatrice: "/assets/equipment/pallinatrice.png",
    abbattitore: "/assets/equipment/abbattitore.png",
  },
};
